var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document-page"},[(_vm.isLoading)?_c('div',{staticClass:"document-page__loading"},[_c('Spin',{attrs:{"fix":""}})],1):_c(_vm.currentDocumentState,{tag:"component",attrs:{"document":_vm.document},on:{"refresh":_vm.getDocument,"create":_vm.setUserDocument}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }